export const Languages = [
  {
    key: 1,
    name: 'English',
    code: 'en',
    file: '',
  },
  {
    key: 2,
    name: 'Nederlands',
    code: 'nl',
    file: '',
  },
  {
    key: 3,
    name: 'বাংলাদেশ',
    code: 'bn',
    file: '',
  },
  {
    key: 4,
    name: 'Deutsch',
    code: 'de',
    file: '',
  },
  {
    key: 5,
    name: 'español',
    code: 'es',
    file: '',
  },
  {
    key: 6,
    name: 'français',
    code: 'fr',
    file: '',
  },
  {
    key: 7,
    name: 'italiano',
    code: 'it',
    file: '',
  },
  {
    key: 8,
    name: '日本語',
    code: 'ja',
    file: '',
  },
  {
    key: 9,
    name: 'português',
    code: 'pt',
    file: '',
  },
  {
    key: 10,
    name: 'Русский',
    code: 'ru',
    file: '',
  },
  {
    key: 11,
    name: 'tiếng việt',
    code: 'vi',
    file: '',
  },
  {
    key: 12,
    name: '中文',
    code: 'zh',
    file: '',
  },
]
